import { Text, Anchor } from '@mantine/core'
import { Link } from 'react-router'
import { useMostReadNews } from './api'
import classes from './News.module.css'
import { Typography } from '../common/typography'

interface MostReadProps {
  competitionId?: number
  title: string
  news_id?: number
}

export function MostRead({ competitionId, title, news_id }: MostReadProps) {
  const { data: mostReadNews } = useMostReadNews(6, competitionId)

  const filteredNews = news_id
    ? mostReadNews.filter((news) => news.news_id !== news_id).slice(0, 5)
    : mostReadNews.slice(0, 5)

  return (
    <div className={classes.mostRead}>
      <Typography
        fc={{ light: 'black', dark: 'gray-3' }}
        fw={500}
        lh="125"
        level={5}
      >
        {title}
      </Typography>
      <div className={classes.mostReadNews}>
        {filteredNews.map((news) => (
          <Anchor
            key={news.news_id}
            component={Link}
            to={`/news/${news.news_id}`}
            className={classes.mostReadLink}
            c="inherit"
            underline="never"
          >
            <Text truncate="end">{news.title}</Text>
          </Anchor>
        ))}
      </div>
    </div>
  )
}
